const menuData = [
    {
        "id": "1",
        "name": "首页",
        "path": "/",
        "icon": "HomeOutlined",
        "closable": false,
        "parent":""
    },
    {
        "id": "2",
        "name": "采购业务",
        "path": "/purchase",
        "icon": "BorderOutlined",
        "closable": true,
        "parent":"",
        "children": [
            {
                "id": "2-3",
                "name": "采购单",
                "path": "/purchase/po",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"2"
            },
            {
                "id": "2-4",
                "name": "采购退货",
                "path": "/purchase/ro",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"2"
            }
        ]
    },
    {
        "id": "3",
        "name": "销售业务",
        "path": "/sale",
        "icon": "ShopOutlined",
        "closable": true,
        "parent":"",
        "children": [
            {
                "id": "3-1",
                "name": "销售订单",
                "path": "/sale/order",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"3"
            },
            {
                "id": "3-2",
                "name": "销售单",
                "path": "/sale/so",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"3"
            },
            {
                "id": "3-3",
                "name": "销售退货",
                "path": "/sale/ro",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"3"
            }
        ]
    },
    {
        "id": "4",
        "name": "库存管理",
        "path": "/stock",
        "icon": "DatabaseOutlined",
        "closable": true,
        "parent":"",
        "children": [
            {
                "id": "4-1",
                "name": "库存统计",
                "path": "/stock/statistic",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"4"
            },
            {
                "id": "4-2",
                "name": "库存盘点",
                "path": "/stock/check",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"4"
            }
        ]
    },
    {
        "id": "5",
        "name": "账单管理",
        "path": "/bill",
        "icon": "DollarCircleOutlined",
        "closable": true,
        "parent":"",
        "children": [
            {
                "id": "5-1",
                "name": "客户账单",
                "path": "/bill/customer",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"5"
            },
            {
                "id": "5-2",
                "name": "供应商账单",
                "path": "/bill/supplier",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"5"
            }
        ]
    },
    {
        "id": "6",
        "name": "基础数据",
        "path": "/base",
        "icon": "ProfileOutlined",
        "closable": true,
        "parent":"",
        "children": [
            {
                "id": "6-1",
                "name": "配件管理",
                "path": "/base/material",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"6"
            }, {
                "id": "6-2",
                "name": "仓库管理",
                "path": "/base/warehouse",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"6"
            }, {
                "id": "6-3",
                "name": "供应商管理",
                "path": "/base/supplier",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"6"
            }, {
                "id": "6-4",
                "name": "客户管理",
                "path": "/base/customer",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"6"
            }, {
                "id": "6-5",
                "name": "数据字典",
                "path": "/base/dict",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"6"
            }, /*{
                "id": "6-6",
                "name": "缓存管理",
                "path": "/setting/cache",
                "icon": "FileOutlined",
                "closable": true
            },*/
        ]
    },
    {
        "id": "7",
        "name": "统计分析",
        "path": "/statistics",
        "icon": "LineChartOutlined",
        "closable": true,
        "parent":"",
        "children": [
            {
                "id": "7-1",
                "name": "配件交易频次",
                "path": "/statistics/partDeal",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"7"
            }, {
                "id": "7-2",
                "name": "进销存明细",
                "path": "/statistics/dinout",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"7"
            }, {
                "id": "7-3",
                "name": "客户销售情况",
                "path": "/statistics/customerSale",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"7"
            }, {
                "id": "7-4",
                "name": "供应商采购情况",
                "path": "/statistics/supplier",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"7"
            }, {
                "id": "7-5",
                "name": "配件或客户销售情况",
                "path": "/statistics/partOrCustomer",
                "icon": "FileOutlined",
                "closable": true,
                "parent":"7"
            }
        ]
    }
]

export default menuData;